var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSwiper
        ? [
            _vm.swiperSlides.length > 0
              ? _c(
                  "swiper",
                  {
                    ref: "swiperRef",
                    staticClass: "dynamic-carousel-container",
                    attrs: {
                      config: _vm.defaultConfig,
                      pagination: true,
                      navigation: true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "navigationprev",
                          fn: function () {
                            return [
                              _c("rb-lazy-icon", {
                                attrs: {
                                  icon: "caret-light-left",
                                  text: "caret-big-left",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "navigationnext",
                          fn: function () {
                            return [
                              _c("rb-lazy-icon", {
                                attrs: {
                                  icon: "caret-light-right",
                                  text: "caret-big-rights",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      760054636
                    ),
                  },
                  _vm._l(_vm.swiperSlides, function (slot, index) {
                    return _c(
                      "rb-dynamic-swiper-slide",
                      { key: index, attrs: { index: index } },
                      [_vm._t("default")],
                      2
                    )
                  }),
                  1
                )
              : _c("rb-loading", { attrs: { loading: true } }),
          ]
        : [
            _c(
              "div",
              { staticClass: "grid dynamic-grid-container grid--gap-1" },
              _vm._l(_vm.swiperSlides, function (slot, index) {
                return _c(
                  "dynamic-grid-stella-product",
                  {
                    key: index,
                    attrs: {
                      index: index,
                      "total-of-slides": _vm.totalOfSlides,
                    },
                  },
                  [_vm._t("default")],
                  2
                )
              }),
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }